import React, { useState } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import TextField from "@material-ui/core/TextField";
import {
  getNextBtnText,
  getShowNextIcon,
  getNextBtnWidth,
  getShowBackBtn,
  getIsValid,
  canEditSessions
} from "EventLight/Sessions/AddSessionModal/selectors";
import { actions, getters } from "EventLight/Sessions/AddSessionModal/model";
import {
  Div,
  BigFilledButton,
  RightArrowIcon,
  LeftArrowIcon,
  BigOutlineButton,
  OpenInNewIcon
} from "components/Base";
import { WithFormInstanceProvider } from "ui-kit/Form/View";
import { getters as TabGetters } from "ui-kit/Tabs";
import {
  SESSION_FORM_ID,
  FROM_SESSION_PAGE,
  TABS,
  SESSION_MODAL_TABS_INSTANCE_ID
} from "EventLight/Sessions/AddSessionModal/constants";
import css from "./footer.scss";
import CSSModules from "react-css-modules";
import Button from "@material-ui/core/Button";
import { noop } from "utils/General";

import { selectFeatureFlag } from "@flopflip/react-redux";
import * as flags from "utils/feature-flags";

const decorate = R.compose(
  CSSModules(css),
  WithFormInstanceProvider(R.always(SESSION_FORM_ID)),
  connect(
    state => ({
      nextBtnText: getNextBtnText(state),
      showNextIcon: getShowNextIcon(state),
      nextBtnWidth: getNextBtnWidth(state),
      showBackBtn: getShowBackBtn(state),
      isValid: getIsValid(state),
      activeTab: TabGetters.selectedTab(state, {
        instanceId: SESSION_MODAL_TABS_INSTANCE_ID
      }),
      loading: getters.loading(state),
      isSubsession: getters.isSubsession(state),
      linkSessionsToSubsessionsTab: getters.linkSessionsToSubsessionsTab(state),
      canEditSessions: canEditSessions(state),
      returnToScene: getters.returnToScene(state),
      sessionId: getters.sessionId(state),
      canViewSessionProfile: selectFeatureFlag(
        flags.CAN_VIEW_SESSION_PROFILE.NAME
      )(state)
    }),
    {
      nextPage: actions.nextPage,
      previousPage: actions.previousPage,
      sendMessage: actions.sendMessage,
      goToParentSession: actions.goToParentSession,
      openFullPage: actions.openFullPage
    }
  )
);

const Footer = ({
  isValid,
  nextBtnText = "",
  nextPage = null,
  showNextIcon = null,
  nextBtnWidth = null,
  loading = false,
  activeTab,
  sendMessage,
  isSubsession,
  goToParentSession,
  canEditSessions,
  returnToScene = null,
  openFullPage = noop,
  sessionId = null,
  canViewSessionProfile
}) => {
  const [message, setMessage] = useState("");
  const send = () => {
    sendMessage(message);
    setMessage("");
  };

  const BackButton = (
    <BigOutlineButton
      LeftIcon={LeftArrowIcon}
      display="row.space-between.center"
      color="neutral5"
      onClick={goToParentSession}
    >
      Back to parent session
    </BigOutlineButton>
  );

  const OpenFullPage = canViewSessionProfile ? (
    <BigOutlineButton
      RightIcon={OpenInNewIcon}
      display="row.space-between.center"
      color="neutral7"
      onClick={openFullPage}
    >
      Open full page
    </BigOutlineButton>
  ) : null;

  if (
    activeTab === TABS.BASIC_DETAILS ||
    activeTab === TABS.OTHER ||
    activeTab === TABS.SUBSESSIONS ||
    activeTab === TABS.CONTENT ||
    returnToScene === FROM_SESSION_PAGE
  ) {
    return (
      <Div
        bg="white"
        bt={1}
        bc="neutral2"
        height={65}
        p={6}
        display="row.space-between.center"
        py={3}
        px={6}
      >
        {isSubsession && returnToScene !== FROM_SESSION_PAGE && (
          <Div display="row" style={{ gap: "8px" }}>
            {BackButton}
            {sessionId && OpenFullPage}
          </Div>
        )}

        <BigFilledButton
          width={nextBtnWidth}
          bg="altB5"
          color="white"
          disabled={!canEditSessions || !isValid || loading}
          onClick={() => (!isValid || loading ? noop : nextPage())}
          RightIcon={showNextIcon ? RightArrowIcon : null}
        >
          {nextBtnText}
        </BigFilledButton>

        {!sessionId || (isSubsession && returnToScene !== FROM_SESSION_PAGE)
          ? null
          : OpenFullPage}
      </Div>
    );
  }

  if (activeTab === TABS.MESSAGES) {
    return (
      <div className={css.sendMessageSection}>
        <div style={{ width: "85%" }}>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Enter your comment"
            className={css.textFieldRoot}
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </div>
        <div style={{ width: "15%" }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            disabled={!message}
            className={css.sendButtonRoot}
            onClick={send}
          >
            Send
          </Button>
        </div>
      </div>
    );
  }

  return <></>;
};

export default decorate(Footer);
